import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { sortByOrder } from "../lib/matrix";
import { localizeAddon, localizePlan, regionMeta, readRegion } from "../lib/pricing";

/** Matrix dataset localized to the user's region - shared by gap / security remediation. */
export default function usePlannerDataset() {
  const [dataset, setDataset] = useState(null);
  useEffect(() => {
    api.matrix().then(setDataset).catch(() => {});
  }, []);
  const region = dataset ? readRegion(dataset) : "us";
  const plans = useMemo(() => (dataset ? sortByOrder(dataset.plans).map((p) => localizePlan(p, region)) : []), [dataset, region]);
  const addons = useMemo(() => (dataset ? dataset.addons.map((a) => localizeAddon(a, region)) : []), [dataset, region]);
  const pricing = useMemo(() => regionMeta(dataset, region), [dataset, region]);
  return { dataset, region, plans, addons, rows: dataset?.rows || [], pricing, symbol: pricing.symbol || "$" };
}
